﻿import { useState } from 'react';
import { Link as RouterLink } from 'react-router';
// @mui
import { styled } from '@mui/material/styles';
import { Stack, Link, Container, Typography, Alert } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// sections
import LoginForm from '../../sections/auth/login/LoginForm';
import AuthLayout from './AuthLayout';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 600,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const [isPasswordStep, setIsPasswordStep] = useState(false);
  const [loginError, setLoginError] = useState('');

  return (
    <AuthLayout pageTitle='Login'>
      <Container maxWidth="md">
        <ContentStyle>
          {isSafari && (
            <Alert severity="info" variant="outlined" sx={{ mb: 2 }}>
              This platform is optimized for Google Chrome.
              For the best experience, please use Chrome.
            </Alert>
          )}

          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
            <Typography variant="h1" sx={{ color: 'text.primary' }}>Sign in</Typography>
            <Stack direction="row" alignItems="center" spacing={3}>
              <Link component={RouterLink} variant="body1_14" to={PATH_AUTH.requestJoin}>
                Request join
              </Link>
              {isPasswordStep && (
                <Link component={RouterLink} variant="body1_14" to={PATH_AUTH.resetPassword}>
                  Forgot password?
                </Link>
              )}
            </Stack>
          </Stack>

          {/* Error alert — shown below the title, same position as original */}
          {!!loginError && (
            <Alert severity="error" sx={{ alignItems: 'center', mb: 2 }}>
              {loginError}
            </Alert>
          )}

          <LoginForm
            onStepChange={(step) => {
              setIsPasswordStep(step === 'password');
              setLoginError('');
            }}
            onError={(msg) => setLoginError(msg)}
          />
        </ContentStyle>
      </Container>
    </AuthLayout>
  );
}